'use client';
import { ChangeEvent, useCallback, useMemo } from 'react';
import {
  cvaAsideHeader,
  cvaAsideHeaderActiveCity,
  cvaAsideHeaderTitle,
  cvaSearch,
  cvaSearchIcon,
  cvaSearchInput,
  cvaTag,
  cvaTags,
} from '../../PvzMapStyles';
import IconSearch from '/public/icons/search3.svg';

type TPvzFilter = 'all' | 'pvz' | 'postamat';

interface Props {
  handleCityClick: () => void;
  activeCity: string;
  onShowBottomSheetToTop: () => void;
  hasPickUpItems: boolean;
  hasPostamatItems: boolean;
  pvzFilter: TPvzFilter;
  setPvzFilter: (val: TPvzFilter) => void;
  search: string;
  onChangeSearch: (val: string) => void;
}

const HeaderShops = ({
  handleCityClick,
  activeCity,
  onShowBottomSheetToTop,
  hasPickUpItems,
  hasPostamatItems,
  pvzFilter,
  setPvzFilter,
  search,
  onChangeSearch,
}: Props) => {
  const hidden = useMemo(() => {
    return ![hasPickUpItems, hasPostamatItems].every(Boolean);
  }, [hasPickUpItems, hasPostamatItems]);

  const filterTabs = useMemo(() => {
    const list: Array<{
      id: TPvzFilter;
      label: string;
    }> = [{ id: 'all', label: 'Все' }];
    if (hasPickUpItems) {
      list.push({
        id: 'pvz',
        label: 'Пункт выдачи',
      });
    }
    if (hasPostamatItems) {
      list.push({
        id: 'postamat',
        label: 'Постамат',
      });
    }

    return list;
  }, [hasPickUpItems, hasPostamatItems]);

  const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    onChangeSearch(e.target.value);
  }, []);

  return (
    <div className={cvaAsideHeader()}>
      <div className={cvaAsideHeaderTitle()}>
        Пункты выдачи
        <br />в{' '}
        <span className={cvaAsideHeaderActiveCity()} onClick={handleCityClick}>
          {activeCity}
        </span>
      </div>
      <div className={cvaSearch()}>
        <input
          type="text"
          className={cvaSearchInput()}
          placeholder={'Поиск по адресу'}
          value={search}
          onChange={onChange}
          onFocus={onShowBottomSheetToTop}
        />
        <IconSearch className={cvaSearchIcon()} />
      </div>
      <div className={cvaTags({ hidden })}>
        {filterTabs.map(({ id, label }) => (
          <div
            key={id}
            className={cvaTag({
              active: pvzFilter === id,
            })}
            onClick={() => setPvzFilter(id)}
          >
            {label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeaderShops;
